//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import UserInfoModule from 'app_components/modules/campus/user/userInfo'
import MyCoursesModule from 'app_components/modules/campus/academic/myCourses'
import ActivityCalendarModule from 'app_components/modules/campus/academic/activityCalendar'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import '../teacherDashboardSidebarModule.scss'

// @ADD Component types
interface ITeacherDashboardSidebarModuleLayoutProps {}

const TeacherDashboardSidebarModuleLayout: React.FC<ITeacherDashboardSidebarModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='teacher_dashboard_sidebar-component'>
      <section className="teacher-user-info">
        <UserInfoModule showChangePassword />
      </section>
      <section className="teacher-my-courses">
        <MyCoursesModule role='teacher'/>
      </section>
      <section className="teacher-activity-calendar">
        <ActivityCalendarModule />
      </section>
    </div>
  )
}

export default TeacherDashboardSidebarModuleLayout
